// START Open Requre.JS wrapper
define([
	'jquery',
	'pubsub',
	'shared.main.screen',
	'jquery.hoverintent',
	'shared.lazyload',
	'wcs.utils'
	], function($, pubsub, screenSize, hoverIntent, lazyload, utils) {
// END Open Require.JS wrapper

	var DEBUG = false;
	var PLUGIN_IDENTIFIER = "topnavdropdown";
	var newTransparentTopNav = false;
	var topnavdropdown;
	var promoBarTopEnabled = WCS_CONFIG.get('topnav::promoBarTopEnabled') || false;
	var renderTopNavForVansEU = WCS_CONFIG.get('topnav::renderTopNavForVansEU') || false;
	var tnfTopNavNewDesignEnabled = WCS_CONFIG.get('topnav::aemTopnavNewDesignEnabled') || false;
	var topNavRateHoverLimit = WCS_CONFIG.get('topnav::topNavrateHoverLimit') || 150;
	var topNavRateHoverLimitAnimationEnabled = WCS_CONFIG.get('topnav::rateHoverLimitAnimationEnabled') || false;
	var enableMobileTopNavForTablet = WCS_CONFIG.get('topnav::enableMobileTopNavForTablet') || false;
	var isTabletDevice = (window.devicePixelRatio >= 2 && (window.innerWidth >= 640 && window.innerWidth <= 1024)) && enableMobileTopNavForTablet;
	(function(){

		/****
		 * Shows/hides navigation dropdowns by clicking the l1 links
		 * visible on medium up screens.
		 ***/
		topnavdropdown = {
			defaults: {
				el: ".topnav-mainnav",
				dataAttr: "topnav-dropdown-options",
				dropdown: ".topnav-dropdown",
				dropdownL3: ".topnav-accordion-l3-dropdown",
				dropdownCloseButton: "topnav-dropdown-close",
				dropdownLink: ".l1.has-children:not('.topnav-list, .more') > a",
				dropdownItem: ".l1.has-children:not('.topnav-list, .more')",
				item: ".topnav-accordion-item",
				itemLink: ".topnav-accordion-item-link",
				l1Item: ".l1:not('.topnav-list, .more')",
				l1MoreItem: ".l1.topnav-accordion-item.more.active",
				l1TopNavListItem: ".l1.topnav-accordion-item.topnav-list.active",
				l1ItemActive: ".l1.active:not('.topnav-list, .more')",
				promoColumn: "topnav-column-promo",
				topnavHeader: '.topnav-header',
				topnavPromobar: '.topnav-promobar',
				shopAll: 'topnav-accordion-shopall',
				stickyMed: '.sticky-medium',
				rateLimit: topNavRateHoverLimit,
				topnav: '.topnav',
				dropdownWrapper: '.topnav-dropdown-wrapper',
				placeholderLink: '.topnav-accordion-item-link.placeholder',
				lazyLoadImages: 'picture.lazy-load',
				topNavNewHeader: '.top-nav-header'
			},

			/**
			 * Initialize Topnav Dropdown Functions
			 **/
			init : function() {
				if ( DEBUG ) console.log('initilizing ' + PLUGIN_IDENTIFIER);

				var self = this; // Make plugin namespace available throughout
				self.deferred = $.Deferred();

				self.menuStatus = 'inactive';

				self.$element = $(self.defaults.el);
				self.metadata = self.$element.data(self.defaults.dataAttr);
				self.config = $.extend( {}, self.defaults, self.metadata );
				self.config.$header = self.$element;
				self.config.$topnav = self.config.$header.closest(self.config.topnav);

				self.$dropdown = self.$element.find(self.config.dropdown);
				self.$dropdownItem = self.$element.find(self.config.dropdownItem);

				self.$l3Containers = $(self.config.dropdownL3);
				self.$l3Controllers = self.$l3Containers.siblings(self.config.itemLink);

				self.$dropdown.find('.' + self.config.promoColumn + ' a').addClass(self.config.promoColumn + '-link');

				self.events();

				self.configureAriaTags();

				self.setColumnOrder(screenSize.size());

				$.pubsub('publish','vfdp.aem.topnav.dropdown.loaded');

				self.deferred.resolve();

				if(self.config.$topnav.closest('.transperant-topnav').length) {
                    newTransparentTopNav = true;
                }

				return self;
			},

			/**
			 * Dropdown events
			 **/
			events : function() {
				var self = this;

				// On Page Init
				self.checkForVisibleDropdowns();

				// Set menu status
				self.toggleMenuStatus(self.$element);

				// Resizing window will trigger hide l1 open dropdown and remove active class
				$.pubsub('subscribe','window.resize.breakpoint',function(event,data) {
					self.configureAriaTags();
					self.setColumnOrder(screenSize.size());
					self.hideDropdown(self.$dropdownItem);
					self.toggleL1KeyboardMenuEvents($(self.config.l1Item));
				});

				// Re-bind dropdown events when item is removed from more menu
				$.pubsub('subscribe', 'vfdp.aem.topnav.moreMenu.remove.dropdown', function(msg, $el) {
					self.bindDropdownMenuEvents($el);
				});

				// Un-bind dropdown events when item is added more menu
				$.pubsub('subscribe', 'vfdp.aem.topnav.moreMenu.add.dropdown', function(msg, $el) {
					self.unbindDropdownMenuEvents($el);
				});

				// Bind mouseover/mouseleave and click/tap events to .l1 items to hide/show dropdown menu
				self.bindDropdownMenuEvents($(self.config.l1Item));

				// Bind keyboard events to all .l1 items in the menu
				self.toggleL1KeyboardMenuEvents($(self.config.l1Item));

				// Clicking/tapping close button will close dropdown
				$('.' + self.config.dropdownCloseButton).on('click touch', function(e) {
					e.preventDefault();
					self.menuStatus = 'inactive';
					self.animateClosed($(this).closest('.l1'));
				});

				// Any open dropdowns should be closed if the More menu is opened
				$.pubsub('subscribe', 'vfdp.aem.topnav.moreDropdown.opened', function() {
					self.hideDropdown(self.$dropdownItem);
				});

				// Prevent # from being added to URL when placeholder links are clicked
				$(self.config.placeholderLink).on('click', function(e) {
					e.preventDefault();
				});
			},

			unbindDropdownMenuEvents: function(el) {
				var self = this;

				el.off('mouseenter mouseleave');
				el.find('> a').off('tap');
				el.off('keydown');
			},

			toggleL1KeyboardMenuEvents: function(el) {
				var self = this;
				el.off('keydown');
				if(screenSize.size() !== "small") {
					el.on('keydown', self, self.topnavMenuKeyDownHandler);
				}
			},

			bindDropdownMenuEvents: function(el) {
				var self = this;

				// Mousing over l1 will open its descendant dropdown and close on mouseleave
				// animate open/closed if other dropdowns are not open
				// else just open directly
				el.hoverIntent({
					over: function() {
						// Open menu item on mouseover
						if(screenSize.size() !== "small" && !isTabletDevice) {

							if(self.menuStatus === 'inactive' && el.hasClass('has-children') && !$(this).hasClass('active')) {
								self.animateOpen($(this));
							} else {
								self.showDropdown($(this));
							}
						}
					},
					out: function() {
						// ...
					},
					timeout: self.config.rateLimit
				});

				// Tapping on l1 item will open/close its descendant dropdown menu
				// use link as element, not item, as item will toggle the dropdown and
				// cause tapping on children elements to
				// close the dropdown instead of continuing to their respective link.
				el.find('> a').on('tap', function(e) {
					var element = $(this).closest(self.config.dropdownItem);

					if(screenSize.size() !== "small" && !isTabletDevice && $(this).closest('.l1').hasClass('has-children')) {
						e.preventDefault();
						// animate open/closed if other dropdowns are not open
						// else just open directly
						if(!element.hasClass('active')) {
							if($(self.config.l1Item).hasClass('active')) {
								self.showDropdown(element);
							} else {
								self.animateOpen(element);
							}
						} else {
							self.animateClosed(element);
						}
					}
				});
			},

			// L3 links are only hidden in an accordion on small screens, so on desktop screens we need
			// to remove the aria attributes such as aria-expanded, aria-controls, and aria-labelledby
			// not to confuse screen readers. Since the attributes are linked to IDs we will rename the
			// aria attributes as data attributes and then replace them when switching back to small screens.
			configureAriaTags: function() {
				var self = this;

				if(screenSize.size() !== "small") {
					self.$l3Containers.each(function(){
						var $el = $(this);
						$el.attr({
							"data-labelledby": $el.attr("aria-labelledby")
						}).removeAttr("aria-labelledby");
					});

					self.$l3Controllers.each(function(){
						var $el = $(this);
						$el.attr({
							"data-expanded": $el.attr("aria-expanded"),
							"data-controls": $el.attr("aria-controls"),
							"data-haspopup": $el.attr("aria-haspopup")
						}).removeAttr("aria-expanded aria-controls aria-haspopup");
					});
				}
				else {
					self.$l3Containers.each(function(){
						var $el = $(this);
						$el.attr({
							"aria-labelledby": $el.attr("data-labelledby")
						}).removeAttr("data-labelledby");
					});

					self.$l3Controllers.each(function(){
						var $el = $(this);
						$el.attr({
							"aria-expanded": $el.attr("data-expanded"),
							"aria-controls": $el.attr("data-controls"),
							"aria-haspopup": $el.attr("data-haspopup")
						}).removeAttr("data-expanded data-controls data-haspopup");
					});
				}
			},

			/**
			 * Dropdown columns can be ordered differently across breakpoints, and the order
			 * for each breakpoint is set as a data attribute on the column. This gets the
			 * value from the data attribute and sets the flex order on the column
			 **/
			setColumnOrder: function(breakpoint) {
				var self = this;

				self.$dropdown.find('.columns').each(function() {
					var $column = $(this),
						order = $column.data('order-' + breakpoint);

					if(typeof order !== "undefined") {
						$column.css('order', order);
					}
				});
			},

			animateOpen: function(element) {
				var self = this,
					$elementsLink = element.find(">" + self.config.itemLink),
					$elementsDropdown = element.find(self.config.dropdown),
					sectionHeight = 0,
					dropdown = $elementsDropdown[0],
					promoBar = $(self.config.topnavPromobar)[0];

				// Callback for when animation completes
				var animationComplete = function() {
					// remove "height" from the element's inline styles, so it can return to its initial value
					dropdown.style.height = '';
					// remove this event listener so it only gets triggered once
					dropdown.removeEventListener('transitionend', animationComplete);
				};

				// close any open siblings
				self.hideDropdown(element.siblings(self.config.dropdownItem));

				if($(self.config.topnavPromobar).hasClass('notransition')) {
					$(self.config.topnavPromobar).removeClass('notransition');
				}

				if(renderTopNavForVansEU && element.hasClass('has-children')) {
					self.generateFullBleedElements(element);
				}

				// Don't animate if the menu doesn't have a dropdown or is already open
				if(element.hasClass('active') || !element.hasClass('has-children')) {
					return true;
				}

				var elements = $elementsDropdown.add(self.config.topnavPromobar);
				utils.interruptTransitions(elements, function() {
					self.toggleTransperantTopNav('show');
					// add active class to l1, set dropdown visible
					element.addClass('active');
					$elementsDropdown.css({'display':'block','height':'0'});

					if ($(self.config.topnavHeader).hasClass('sticky-minimized')) {
						$(self.config.topnavPromobar).removeClass('hide');
					}

					// get height of dropdown
					sectionHeight = dropdown.scrollHeight;
				});

				// Setup event listener for the css transition finishes
				dropdown.addEventListener('transitionend', animationComplete);

				// Set accessibility state
				$elementsLink.attr({'aria-expanded':'true'});

				// Add event to close dropdown when user interacts outside the menu
				$(document).on('click touchstart scroll', self, self.topnavDismiss);

				// Start the element transition to the height of dropdown content
				dropdown.style.height = sectionHeight + 'px';

				// Move promoBar if config is not enabled
				if(!promoBarTopEnabled) {
					promoBar.style.top = sectionHeight + 'px';
				}

				$.pubsub('publish','vfdp.aem.topnav.dropdown.animate.opened');
			},

			calculateFlyoutFullBleed: function($accordion) {
				var viewportWidth = $(window).width(),
						topnavWidth = $('.topnav').width(),
						topnavMargin = (viewportWidth - topnavWidth) / -2;

				$accordion
					.find('.topnav-dropdown')
					.css('marginLeft', topnavMargin);
			},

			generateFullBleedElements: function($el) {
				var self = this;

				if ($el.hasClass('has-children')) {
					$el.addClass('full-bleed');

					self.calculateFlyoutFullBleed($el);

					$(window).on('resize',function(e) {
						self.calculateFlyoutFullBleed($el);
					});
				}
			},

			toggleTransperantTopNav: function(navState) {	
                var self = this,
                topNavNewBar = $(self.config.topNavNewHeader);
				
				if(!newTransparentTopNav) return;

				if(document.querySelector(self.config.l1MoreItem) || document.querySelector(self.config.l1TopNavListItem) ) return;

                if(navState == 'show') {
                    topNavNewBar.addClass('new-transperant-topnav')
                }else{
                    topNavNewBar.removeClass('new-transperant-topnav')
                }   
            },

			animateClosed: function(element) {
				var self = this,
					$elementsLink = element.find(">" + self.config.itemLink),
					$elementsDropdown = element.find(self.config.dropdown),
					sectionHeight = 0,
					dropdown = $elementsDropdown[0],
					promoBar = $(self.config.topnavPromobar)[0],
					elementTransition,
					elementTransitionPromobar;

				var animationComplete = function() {
					// at the end of the transition remove element's inline styles, so it can return to its initial value
					dropdown.style.display = '';
					dropdown.style.height = '';
					$elementsDropdown.closest('.l1').removeClass('active');
					self.toggleTransperantTopNav('hide');
					if ($(self.config.topnavHeader).hasClass('sticky-minimized') && !promoBarTopEnabled) {
						$(self.config.topnavPromobar).addClass('hide');
					} else {
						$(self.config.topnavPromobar).css({'top':''});
					}

					// remove this event listener so it only gets triggered once
					dropdown.removeEventListener('transitionend', animationComplete);
				};

				if($(self.config.topnavPromobar).hasClass('notransition')) {
					$(self.config.topnavPromobar).removeClass('notransition');
				}

				// get height of current dropdown
				sectionHeight = dropdown.scrollHeight;

				// Set accessibility state
				$elementsLink.attr({'aria-expanded':'false'});

				// Unbind event to close dropdown when user interacts outside the menu
				$(document).off('click touchstart scroll', self, self.topnavDismiss);

				// on the first frame explicitly set the element's height to its current pixel height,
				// so we aren't transitioning out of 'auto'
				requestAnimationFrame(function() {
					var elements = $elementsDropdown.add(self.config.topnavPromobar);

					utils.interruptTransitions(elements, function() {
						// set the element's height to its current pixel height before restoring transitions
						dropdown.style.height = sectionHeight + 'px';
						// Move promoBar if config is not enabled
						if(!promoBarTopEnabled) {
							promoBar.style.top = sectionHeight + 'px';
						}
					});

					// on the next frame (as soon as the previous style change has taken effect)
					// setup the complete listener and trigger the transition
					requestAnimationFrame(function() {
						dropdown.addEventListener('transitionend', animationComplete);

						// Start regular transition height to 0
						dropdown.style.height = 0 + 'px';
						promoBar.style.top = 0 + 'px';
					});
				});
			},

			/*
			* Checks for visible dropdown (if any) on page load and then sets the corresponding link item to active.
			* Removes the default class from the element selector
			*/
			checkForVisibleDropdowns: function() {
				var self = this,
					$visibleDropdown = $(self.config.dropdown + ':visible');

				// If an active dropdown is found, set menuStatus to active
				// and give the dropdown properties needed to animating closed.
				if( $visibleDropdown.length > 0 ) {
					var $visibleDropdownParentItem = $visibleDropdown.closest(self.config.dropdownItem);

					// add mouseleave event to L1 since it did not get added on mouseenter
					$visibleDropdownParentItem.one('mouseleave', function() {
						self.$element.removeClass('topnav-mainnav-no-js');
					});

					// add mouseleave event on MainNav since it did not get added on mouseenter
					self.$element.one('mouseleave', self, self.dropdownDismissHandler);
				}

				// If no active dropdowns are found, remove the default
				// class that styles the active dropdown element on load
				else {
					self.$element.removeClass('topnav-mainnav-no-js');
				}

			},

			dropdownDismissHandler: function(event) {
				var self = event.data,
					target = $(event.target);

				// if mousing off of dropdown or promobar close the open dropdown
				if( !(target.is(self.$element) || target.is(self.config.dropdownWrapper) || target.is(self.config.topnavPromobar)) ) {
					if(self.$dropdownItem.hasClass('active')) {
						self.animateClosed($(self.config.l1ItemActive));
						self.menuStatus = 'inactive';
					}
				}
			},

			/*
			* Sets menu status to inactive or active
			*/
			toggleMenuStatus: function(el) {
				var self = this;

				var mainMenuDismissHandler = function(event) {
					var self = event.data;
					// the mainnav menu flexes the entire empty space between logo and searchbox
					// if mousing over the empty menu space but not an actual L1 and an L1 is open, close it and reset menu status
					if($('.l1.more').hasClass('hide') && self.$dropdownItem.hasClass('active')) {
						if( ($(event.target) === $(event.currentTarget)) || $(event.target).is(self.$element) ) {
							if (topNavRateHoverLimitAnimationEnabled) {
								setTimeout(function() {
									self.animateClosed($(self.config.l1ItemActive));
									self.menuStatus = 'inactive';
								}, self.config.rateLimit)
							} else {
								self.hideDropdown($(self.config.l1ItemActive));
								self.menuStatus = 'inactive';
							}
						}
					}
				};

				el.hoverIntent({
					over: function(event) {
						if(screenSize.size() !== "small") {
							self.menuStatus = 'active';
							if(self.$dropdownItem.hasClass('active')) {
								$(this).one('mouseleave', self, self.dropdownDismissHandler);
								$(this).on('mousemove', self, mainMenuDismissHandler);
							}
						}
					},
					out: function() {
						if(screenSize.size() !== "small") {
							self.menuStatus = 'inactive';
							$(this).off('mousemove', self, mainMenuDismissHandler);
						}
					},
					timeout: self.config.rateLimit
				});

				el.closest(self.config.topnavHeader).hoverIntent({
					over: function(el){
						// lazy load all images within the topnav when hovering over
						if(screenSize.size() !== "small") {
							$(this).find(self.config.lazyLoadImages).lazyload();
						}
					},
					out: function() {
						// close dropdown if one is open
						if(screenSize.size() !== "small") {
							if(self.$dropdownItem.hasClass('active')) {
								self.animateClosed($(self.config.l1ItemActive));
								$(this).off('mousemove', self, mainMenuDismissHandler);
								$(this).off('mouseleave', self, self.dropdownDismissHandler);
								self.menuStatus = 'inactive';
							}
						}
					},
					timeout: self.config.rateLimit
				});
			},

			/** Hide Dropdown function
			* removes active class from l1,
			* and resets position of topnav-promobar
			*/
			hideDropdown: function(el) {
				var self = this,
					$elementsLink = el.find(">" + self.config.itemLink),
					$elementsDropdown = el.find(self.config.dropdown),
					$promoBar = $(self.config.topnavPromobar);

				$elementsDropdown.css({'transition':'', 'display': '', 'height': ''});
				$elementsLink.attr({'aria-expanded':'false'});
				// remove active class from l1
				self.toggleTransperantTopNav('hide');
				el.removeClass('active');
				el.siblings(self.config.dropdownItem).removeClass('active');

				if ($(self.config.topnavHeader).hasClass('sticky-minimized') && !promoBarTopEnabled) {
					$promoBar.addClass('hide');
				}

				// remove transition duration so that promobar doesnt continue animating
				$promoBar.addClass('notransition').css({'top':0});

				// Unbind the global onetime click events
				$(document).off('click touchstart scroll', self, self.topnavDismiss);
			},

			/** Show Dropdown function
			* first hides open dropdown siblings then, adds active class to l1
			* and adds height of dropdown to top of topnav-promobar
			*/
			showDropdown: function(el) {
				var self = this,
				dropdownHeight,
				$elementsLink = el.find(">" + self.config.itemLink),
				$elementsDropdown = el.find(self.config.dropdown),
				$promoBar = $(self.config.topnavPromobar);

				// close any open siblings
				self.hideDropdown(el.siblings(self.config.dropdownItem));

				if(el.hasClass('has-children')) {
					self.toggleTransperantTopNav('show');
					el.addClass('active');
					$elementsDropdown.css({'transition':'','display': 'block'});

					// get height after element is visible
					dropdownHeight = $elementsDropdown.outerHeight();
					if ($(self.config.topnavHeader).hasClass('sticky-minimized') && !promoBarTopEnabled) {
						$(self.config.topnavPromobar).removeClass('hide');
					}

					$elementsDropdown.css({'height': dropdownHeight});

					if(!tnfTopNavNewDesignEnabled) {
						// remove transition duration so that promobar doesnt continue animating
						$promoBar.addClass('notransition').css({'top': dropdownHeight});
					}

					if(renderTopNavForVansEU) {
						self.generateFullBleedElements(el);
					}

				} else {
					if ($(self.config.topnavHeader).hasClass('sticky-minimized') && !promoBarTopEnabled) {
						$(self.config.topnavPromobar).addClass('hide');
					}
				}

				$elementsLink.attr({'aria-expanded':'true'});
				$(document).on('click touchstart scroll', self, self.topnavDismiss);

				// Publish event notifying other plugins the Dropdown is opened
				$.pubsub('publish','vfdp.aem.topnav.dropdown.opened');
			},

			// when a user clicks outside the dropdown menu or scrolls, close the dropdown
			topnavDismiss: function(event) {
				var self = event.data;

				if (!$(event.target).closest(self.config.dropdownItem).length && !$(event.target).closest(self.config.dropdown).length) {
					self.hideDropdown($(self.config.dropdownItem));
				}
			},

			// adds tabindex to items in dropdown menu
			addTabIndexToDropdownElements: function(el) {
				var self = this,
					links = "a:not(.l2 ." + self.config.shopAll + "-link)";

				$(el).each(function(index, obj) {
					var tabbableElements = $(obj).find(links);

					for(var i = 0; i < tabbableElements.length; i++) {
						$(tabbableElements[i]).attr('tabindex', i);
					}
				});
			},

			/**
			* Handles keyboard events for l1s and dropdown elements
			* for user accessibility interactions
			* @param event JQuery Event
			**/
			topnavMenuKeyDownHandler: function(event) {
				var self = event.data,
					$this = $(this),
					$focusedLink = $this.find($(":focus")), // the <a> in the nagivation
					$focusedParent = $focusedLink.parent(), // the <li> wrapping the focused <a>
					$focusedDropdown = $focusedParent.closest(self.config.dropdownWrapper),
					$col = $focusedParent.closest('.columns'),
					$nextLink,
					$prevLink,
					hasChildren = $focusedParent.hasClass('has-children'),
					hasDropdown = (hasChildren && $focusedParent.hasClass('l1')),
					keys = {
						down: 40,
						enter: 13,
						esc: 27,
						left: 37,
						right: 39,
						space: 32,
						tab: 9,
						up: 38
					};

				// This function will return the first link in the dropdown. Depending on how content is authored,
				// this will either be the Shop All link or the first category link.
				function getFirstLink() {
					var $firstLink = $focusedDropdown.find('> .' + self.config.shopAll + ' a');
					if(!$firstLink.length) {
						$firstLink = $focusedDropdown.find('> .row > .columns:first-child').find('.l2').first();
					}
					return $firstLink;
				}

				// This function returns the first link from the next column. Depending on how content is authored,
				// this will either be the first category link in the next column, or a link in the promo content
				function getNextColumnLink($nextCol) {

					// next column
					if($nextCol.length) {
						if($nextCol.hasClass(self.config.promoColumn) && $nextCol.find('.' + self.config.promoColumn + '-link').length) {
							$nextLink = $nextCol.find('.' + self.config.promoColumn + '-link').first();
						}
						else {
							$nextLink = $nextCol.find('.l2').first();
						}
					}
					// move to first link in dropdown
					else {
						$nextLink = getFirstLink();
					}

					return $nextLink;
				}

				switch(event.keyCode) {

					// *** ENTER or SPACE ***
					// If item has a dropdown, toggle the dropdown open/closed.
					// When opening a dropdown, close button receives focus.
					// When focused on close button, close the dropdown.
					// Otherwise, use default action for pressed key.
					case keys.space:
					case keys.enter:
						// if focus on L1 with dropdown, toggle dropdown open/close
						if(hasDropdown) {
							event.preventDefault();
							// close dropdown
							if($focusedParent.hasClass('active')) {
								self.hideDropdown($this);
							}
							// open drodown, focus on close button
							else {
								self.showDropdown($this);
								$focusedParent.find('.' + self.config.dropdownCloseButton).focus();
							}
						}
						// if focused on close button, close drodown
						else if($focusedLink.hasClass(self.config.dropdownCloseButton)) {
							event.preventDefault();
							self.hideDropdown($this);
							$focusedLink.closest('.l1').find('> ' + self.config.itemLink).focus();
						}
					break;

					// *** DOWN ARROW ***
					// When focus is on an L1 that contains a dropdown, open the dropdown and focus on close button
					// When focus is inside a dropdown, focus moves to next item within dropdown
					// Focus should cycle through the current dropdown, excluding close button
					case keys.down:

						event.preventDefault();

						// If L1, open dropdown and focus on close button
						if(hasDropdown) {
							self.showDropdown($this);
							$focusedParent.find('.' + self.config.dropdownCloseButton).focus();
						}

						// Cycle through items within dropdown
						else {
							var $nextCol = $col.next();
							$nextLink = $focusedParent.next();

							// Move focus from close button to first link in dropdown
							if($focusedLink.hasClass(self.config.dropdownCloseButton)) {
								$nextLink = getFirstLink();
							}

							// Move focus from shop all link to first category link
							else if($focusedLink.hasClass(self.config.shopAll + '-link')) {
								$nextLink = $focusedDropdown.find(self.config.item).first();
							}

							// Move focus from L2 to L3 children
							else if(hasChildren) {
								$nextLink = $focusedParent.find('.l3').first();
							}

							// Move focus from last L2 in column to the next column or first link in dropdown
							else if($focusedParent.hasClass('l2') && $focusedParent.is(':last-child')) {
								$nextLink = getNextColumnLink($nextCol);
							}

							// Move focus from last L3 to next L2, next column, or first link in dropdown
							else if($focusedParent.hasClass('l3') && $focusedParent.is(':last-child')) {
								// next L2
								$nextLink = $focusedParent.closest('.l2').next();

								// if L3 is last in the column, move to the next column or first link in dropdown
								if(!$nextLink.length) {
									$nextLink = getNextColumnLink($nextCol);
								}
							}

							// Move focus to next promo link or first link in dropdown
							else if($focusedLink.hasClass(self.config.promoColumn + '-link')) {
								// move focus from media link to first cta link
								if($focusedParent.hasClass('media')) {
									$nextLink = $col.find('.' + self.config.promoColumn + '-text a').first();
								}

								// move focus to next cta link
								if($focusedParent.hasClass(self.config.promoColumn + '-text')) {
									$nextLink = $focusedLink.next('a');
								}

								// move focus to first link in dropdown if no more promo links
								if(!$nextLink.length) {
									$nextLink = getFirstLink();
								}
							}

							if($nextLink.is('a')) $nextLink.focus();
							else $nextLink.find('> a').focus();
						}
					break;

					// *** UP ARROW ***
					// When focus is inside a dropdown, focus moves to previous item within dropdown.
					// Focus should cycle through the current dropdown, excluding close button
					case keys.up:
						event.preventDefault();

						var $prevCol = $col.prev();

						$prevLink = $focusedParent.prev();

						// Move focus from shop all link to last link in dropdown
						if($focusedLink.hasClass(self.config.shopAll + '-link')) {
							$prevLink = $focusedDropdown.find('> .row > .columns:last-child a').last();
						}

						// Move focus from first L2 link to shop all link or last link in dropdown
						else if($focusedParent.hasClass('l2') && $focusedParent.is(':first-child')) {
							if($col.is(':first-child')) {
								// move focus to shop all link
								$prevLink = $focusedDropdown.find(' > .' + self.config.shopAll + ' a');

								// If no shop all link, move focus to last link in last column
								if(!$prevCol.length) {
									$focusedDropdown.find('> .row > .columns:last-child a').last();
								}
							} else {
								$prevLink = $prevCol.find('a').last();
							}
						}

						// Move focus from L2 to last L3 child of previous L2
						else if($prevLink.hasClass('has-children')) {
							$prevLink = $prevLink.find('a').last();
						}

						// Move focus from L3 to L2 parent
						else if($focusedParent.hasClass('l3') && $focusedParent.is(':first-child')) {
							$prevLink = $focusedParent.closest('.l2');
						}

						// Move focus to previous promo link or lest link in previous column
						else if($focusedLink.hasClass(self.config.promoColumn + '-link')) {
							// move focus to previous cta link
							if($focusedParent.hasClass(self.config.promoColumn + '-text')) {
								$prevLink = $focusedLink.prev('a');
							}

							// move focus to media link if no more ctas
							if(!$prevLink.length && !$focusedParent.hasClass('media')) {
								$prevLink = $col.find('.' + self.config.promoColumn + '-media a');
							}

							// move focus to last link in previous column if no media link
							if(!$prevLink.length) {
								$prevLink = $prevCol.find('a').last();
							}
						}

						if($prevLink.is('a')) $prevLink.focus();
						else $prevLink.find('> a').focus();

					break;

					// *** RIGHT ARROW ***
					// When focus is on an L1, focus moves to the next L1
					// When focus is inside a dropdown, focus moves to next column
					// Focus should cycle through the L1 items or columns within a dropdown
					case keys.right:
						event.preventDefault();

						// cycle through L1 items
						if($focusedParent.hasClass('l1')) {
							// move focus to next L1
							$nextLink = $focusedParent.next(':visible').find('> a');
							// move focus to first L1
							if(!$nextLink.length) {
								$nextLink = self.$element.find('.l1').first().find('> a');
							}
						}

						// cycle through columns within dropdown
						else {
							// focus on next column
							$nextLink = $col.next().find('a').first();
							// focus on first column
							if(!$nextLink.length) {
								$nextLink = $col.siblings().first().find('a').first();
							}
						}
						$nextLink.focus();
					break;

					// *** LEFT ARROW ***
					// When focus is on an L1, focus moves to the previous L1
					// When focus is inside a dropdown, focus moves to previous column
					// Focus should cycle through the L1 items or columns within a dropdown
					case keys.left:
						event.preventDefault();

						// cycle through L1 items
						if($focusedParent.hasClass('l1')) {
							// move focus to previous L1
							$prevLink = $focusedParent.prev().find('> a');
							// move focus to last L1
							if(!$prevLink.length) {
								$prevLink = self.$element.find('.l1:visible').last().find('> a');
							}
						}

						// cycle through columns within dropdown
						else {
							// focus on previous column
							$prevLink = $col.prev().find('a').first();
							// focus on last column
							if(!$prevLink.length) {
								$prevLink = $col.siblings().last().find('a').first();
							}
						}
						$prevLink.focus();
					break;

					// *** ESC ***
					// When focused inside a dropdown, closes a dropdown
					case keys.esc:
						if($focusedLink.closest('.l1').hasClass('active')) {
							event.preventDefault();
							self.hideDropdown($this);
							$focusedLink.closest('.l1').find('> ' + self.config.itemLink).focus();
						}
					break;
				}
			}
		};

		// Initialize Dropdowns
		return topnavdropdown.init();

	})();


	return topnavdropdown;


// START close Require.JS wrapper
});
// END close Require.JS wrapper
